"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const react_i18next_1 = require("react-i18next");
const FinishScreenWeb_1 = __importDefault(require("../common/FinishScreenWeb"));
const CancelFlightSuccessWeb = () => {
    const flightData = (0, react_redux_1.useSelector)(selectors_1.getFlightDetails);
    const userDetails = (0, react_redux_1.useSelector)(selectors_1.getUser);
    const userIsFlightPilot = userDetails?.id === flightData?.pilot?.app_user?.id;
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'success_info_page' });
    let title = null;
    let subtitle = null;
    if (userIsFlightPilot) {
        title = t('flight_canceled');
        subtitle = t('flight_canceled_message');
    }
    else {
        title = t('reservation_canceled');
        subtitle = t('reservation_canceled_message');
    }
    return (0, jsx_runtime_1.jsx)(FinishScreenWeb_1.default, { type: "Canceled", title: title, subtitle: subtitle, showMyFlightsBtn: true });
};
exports.default = CancelFlightSuccessWeb;
